import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Enrollment } from './enrollment.model';
import { EnrollmentPopupService } from './enrollment-popup.service';
import { EnrollmentService } from './enrollment.service';
import { Payment, PaymentService, PaymentType} from '../payment';
import { PaymentItem, PaymentItemService} from '../payment-item';
import { StudentTypeaheadService } from '../student';
import { CRUD_ACTIONS, Principal } from '../../shared';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { SchoolService } from '../school';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-enrollment-pay-dialog',
    templateUrl: './enrollment-pay-dialog.component.html'
})
export class EnrollmentPayDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy  {

    enrollment: Enrollment;
    payment: Payment;
    paymentItem: PaymentItem;
    isSaving: boolean;

    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.payment.payer['user']);

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private enrollmentService: EnrollmentService,
        public activeModal: NgbActiveModal,
        public studentTypeaheadService: StudentTypeaheadService,
        public schoolService: SchoolService,
        public alertService: AlertService,
        public principal: Principal,
        public paymentService: PaymentService,
        public paymentItemService: PaymentItemService,
        private eventManager: EventManager
    ) {
        super(schoolService, alertService, principal);
    }

    clear() {
        this.isSaving = false;
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.payment.payer instanceof Object) {
            this.isSaving = true;
            this.paymentService.create(this.payment)
                .subscribe((res: Payment) =>
                    this.onPaymentSaveSuccess(res, CRUD_ACTIONS.CREATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            let payerInput = form !== undefined ? form.controls['payer'] : null;
            if (payerInput !== null) {
                payerInput.reset();
            }
        }
    }

    private onPaymentSaveSuccess(result: Payment, action: string) {
        this.paymentItem.payment = result;
        this.paymentItemService.create(this.paymentItem)
                .subscribe((res: PaymentItem) =>
                    this.onPaymentItemSaveSuccess(res),
                    (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onPaymentItemSaveSuccess(result: PaymentItem) {
        this.enrollment.totalPaid += this.paymentItem.amount;
        this.eventManager.broadcast({ name: 'enrollmentListModification',  content: {
            action: CRUD_ACTIONS.UPDATE,
            content: this.enrollment
        } });
        this.eventManager.broadcast({ name: 'paymentItemListModification',  content: {
            action: CRUD_ACTIONS.CREATE,
            content: result
        } });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    ngOnInit() {
        this.payment = new Payment();
        this.payment.payer = this.enrollment.student;
        let today: Date = new Date();
        this.payment.paymentDate = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate()
        };
        this.paymentItem = new PaymentItem();
        this.paymentItem.beneficiary = this.enrollment.student;
    }

    ngOnDestroy() {

    }

}

@Component({
    selector: 'jhi-enrollment-pay-popup',
    template: ''
})
export class EnrollmentPayPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private enrollmentPopupService: EnrollmentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.enrollmentPopupService
                .open(EnrollmentPayDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment-pay-dialog.component.ts